import { api } from '../../../api';
import HubPageLayout from '../../../common/hub/HubPageLayout';
import { FullPageLoader } from '../../../components/Loader/Loader';
import { HeroBanner } from './HeroBanner';
import { HomeHero } from './hero';
import { HomeWidgets } from './widgets';
import CustomerSupportInfo from '../../../v2/common/CustomerSupportInfo';

export const HomePage = () => {
  const { data, isLoading } = api.account.details.useQuery();

  if (isLoading) return <FullPageLoader />;

  const isLead = 'userType' in data && data.userType === 'Lead';

  return (
    <HubPageLayout noContainer>
      <div id="home_banner">
        <HeroBanner />
      </div>
      <HomeHero isLead={isLead} />
      <HomeWidgets isLead={isLead} />
      <CustomerSupportInfo />
    </HubPageLayout>
  );
};
